export const TITLE_OFFLINE = `You're offline`;
export const TEXT_OFFLINE = 'Check your Internet connection and reload the page.';
export const TITLE_NETWORK_ISSUES = `Can't connect to LiveChat`;
export const TRY_AGAIN_BUTTON_TEXT = 'Reload';
export const OPEN_CHAT_WIDGET_BUTTON_TEXT = 'Contact support';
export const OPEN_CHAT_WIDGET_EVENT_NAME = 'Opened Chat Widget';
export const DEFAULT_ERROR_MESSAGE = 'Network issues.';
